import { gql } from '@apollo/client';

export const UPDATE_PROJECT = gql`
  mutation UpdateProject($id: ID!, $input: ProjectUpdateInput!) {
    updateProject(id: $id, input: $input) {
      id
      ownerId
      name
      status
      meta
      users {
        id
        email
        name
        role
      }
    }
  }
`;

export const UPDATE_PHASE = gql`
  mutation UpdatePhase($id: ID!, $input: PhaseUpdateInput!) {
    updatePhase(id: $id, input: $input) {
      id
      projectId
      name
      type
      progress
      sequence
      locked
      status
      isActive
      isHidden
      meta
      data
      users {
        id
        email
        name
        role
      }
      notes {
        id
        text
        createdAt
        authorId
      }
    }
  }
`;
